import React from 'react'

function TenderTextCombined() {
  return (
    <embed src="\pdfs\EAT1.2.1.2_FA-VK_Combined_multiplex_outlet_kr.pdf" width="100%" height="2100px" />
  )
}

export default TenderTextCombined